<h3 mat-dialog-title>PASSWORT ZURÜCKSETZEN</h3>
<div mat-dialog-content>
    <form [formGroup]="dataForm" fxLayout="column">
        <mat-form-field>
            <mat-label>Neues Passwort*:</mat-label>
            <input matInput type="password" formControlName="newPassword">
            <mat-error *ngIf="dataForm.get('newPassword').hasError('minlength')">Zu kurz</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Passwort wiederholen*:</mat-label>
            <input matInput type="password" formControlName="passwordRecitation">
            <mat-error *ngIf="dataForm.hasError('passwordsDoNotMatch')">
                    Passwort stimmt nicht überein
                  </mat-error>
        </mat-form-field>
    </form>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Abbrechen</button>
    <button mat-button [mat-dialog-close]="dataForm.value" cdkFocusInitial [disabled]="dataForm.invalid">Passwort setzen</button>
</div>